import { EdgeExchangeTransferCodeRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { ExchangeTransferCode } from '@/modules/auth/use-cases'

export function makeExchangeTransferCode(): ExchangeTransferCode {
  return new EdgeExchangeTransferCodeRepository(makeSupabaseEdgeHttpClient()).execute
}
